import 'react-app-polyfill/ie11'; // eslint-disable-line import/order
import 'react-app-polyfill/stable'; // eslint-disable-line import/order

import React from 'react';

import ReactDOM from 'react-dom';

import { App } from 'App';
// import * as serviceWorker from "./serviceWorker";

import axeConfig from './axeConfig';

declare global {
    interface Window {
        chrome?: boolean;
        pendo?: any;
    }
}

// React Axe works perfectly with chrome, and may cause some interference in firefox
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DISABLE_AXE !== 'true') {
    // eslint-disable-next-line import/no-extraneous-dependencies
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 6000, axeConfig);
    });
}

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);

// serviceWorker.unregister();
